import { render, staticRenderFns } from "./activityOrderApprove.vue?vue&type=template&id=0702eb5a&scoped=true"
import script from "./activityOrderApprove.vue?vue&type=script&lang=js"
export * from "./activityOrderApprove.vue?vue&type=script&lang=js"
import style0 from "./activityOrderApprove.vue?vue&type=style&index=0&id=0702eb5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0702eb5a",
  null
  
)

export default component.exports